import { Instagram as InstagramIcon, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, INSTAGRAM_POSTS } from "@/data/content";

const InstagramHeader = () => (
    <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
            <div className="flex items-center gap-4">
                <span className="h-px w-10 bg-terra/50" />
                <span className="text-xs uppercase tracking-[0.25em] text-timber">Follow the Journey</span>
            </div>
            <h2 className="mt-6 font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
                Latest from <em className="text-terra">{CONTACT.instagram}</em>
            </h2>
            <p className="mt-4 max-w-lg text-sm font-light leading-relaxed text-mute sm:text-base">
                Site diaries, craft details, and finished spaces — a living journal of work conceived together.
            </p>
        </div>
        <a
            data-testid="instagram-follow-btn"
            href={CONTACT.instagramHref}
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-3 rounded-full border border-wood/25 px-7 py-3.5 text-xs uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:border-ink hover:bg-ink hover:text-ivory"
        >
            <InstagramIcon size={15} strokeWidth={1.5} />
            Follow on Instagram
            <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
    </div>
);

const InstagramPost = ({ post, index }) => (
    <a
        data-testid={`instagram-tile-${index + 1}`}
        href={CONTACT.instagramHref}
        target="_blank"
        rel="noreferrer"
        aria-label={post.caption}
        className="group relative block overflow-hidden"
    >
        <img
            src={post.src}
            alt={post.alt}
            loading="lazy"
            className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.08]"
        />
        <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-night/80 via-night/10 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
            <InstagramIcon size={16} strokeWidth={1.5} className="mb-2 text-gold" />
            <p className="text-[11px] font-light leading-snug text-ivory">{post.caption}</p>
        </div>
    </a>
);

export const Instagram = () => (
    <section data-testid="instagram-section" className="border-t border-wood/10 bg-sand py-20 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
            <Reveal>
                <InstagramHeader />
            </Reveal>
            <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-6">
                {INSTAGRAM_POSTS.map((post, i) => (
                    <Reveal key={post.id} delay={0.06 * i} y={24} className={i % 2 === 1 ? "lg:mt-8" : ""}>
                        <InstagramPost post={post} index={i} />
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
